import gql from 'graphql-tag';
import { DsrFragments } from '@getaccept/lib-shared/src/library/graphql/dsr.fragments';
import { editorBlockFragment } from '@getaccept/editor-lib';
import {
  editorBlockDocumentListFragment,
  productListFragment,
  editorBlockDocumentFragment,
} from './editor-block.fragments';

export const imageLibrarySearchQuery = gql`
  query imageLibrarySearch($search: String!, $page: Float, $perPage: Float) {
    imageLibrarySearch(search: $search, page: $page, perPage: $perPage) {
      total
      totalPages
      images {
        id
        url
        rawUrl
        username
        name
        altDescription
        height
        width
      }
    }
  }
`;

export const trackImageLibraryDownloadQuery = gql`
  query trackImageLibraryDownload($imageId: String!) {
    trackImageLibraryDownload(imageId: $imageId)
  }
`;

export const convertToImagesPostLinkQuery = gql`
  query convertToImagesPostLink($filename: String!) {
    convertToImagesPostLink(filename: $filename) {
      uploadLink {
        url
        headers
      }
      uniqueFilename
    }
  }
`;

export const loadContent = gql`
  query loadContent(
    $directory: String
    $resourceType: ResourceType
    $searchTerms: [String!]!
    $limit: Int!
    $offset: Int!
    $sortBy: ResourceSortAttributes!
    $sortOrder: String!
  ) {
    resources(
      directory: $directory
      resourceType: $resourceType
      searchTerms: $searchTerms
      limit: $limit
      offset: $offset
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      resources {
        id
        contentId
        title
        updatedAt
      }
    }
  }
`;

export const loadDsrContent = gql`
  query loadDsrContent(
    $directory: String
    $resourceType: DsrResourceType
    $searchTerms: [String!]!
    $limit: Int!
    $offset: Int!
    $sortBy: DsrSortAttribute!
    $sortOrder: SortOrder
    $userIds: [String!]
    $tagIds: [String!]
  ) {
    dsrResources(
      directory: $directory
      resourceType: $resourceType
      searchTerms: $searchTerms
      limit: $limit
      offset: $offset
      sortBy: $sortBy
      sortOrder: $sortOrder
      userIds: $userIds
      tagIds: $tagIds
    ) {
      resources {
        ...dsrResourceFragment
      }
      totalCount
    }
  }
  ${DsrFragments.resource}
`;

export const loadResourceIdsInDirectory = gql`
  query loadDsrContent(
    $directory: String
    $resourceType: DsrResourceType
    $searchTerms: [String!]!
    $limit: Int!
    $offset: Int!
    $sortBy: DsrSortAttribute!
    $sortOrder: SortOrder
    $userIds: [String!]
    $includeSubDirectories: Boolean
    $tagIds: [String!]
  ) {
    dsrResources(
      directory: $directory
      resourceType: $resourceType
      searchTerms: $searchTerms
      limit: $limit
      offset: $offset
      sortBy: $sortBy
      sortOrder: $sortOrder
      userIds: $userIds
      includeSubDirectories: $includeSubDirectories
      tagIds: $tagIds
    ) {
      resources {
        id
      }
    }
  }
`;

export const loadResource = gql`
  query dsrResource($id: String!) {
    dsrResource(id: $id) {
      ...dsrResourceFragment
    }
  }
  ${DsrFragments.resource}
`;

export const loadContentPlaceholderResource = gql`
  query dsrContentPlaceholderResource($id: String!) {
    dsrResource(id: $id) {
      id
      title
      contentId
      deletedAt
    }
  }
`;

export const getDocumentsQuery = gql`
  query documents(
    $documentFilter: DocumentFilter!
    $userIds: [String!]
    $orderBy: String
    $limit: Int
    $offset: Int
    $tagIds: [String!]
    $withoutTags: Boolean
    $nameSearch: String
  ) {
    getDocuments(
      documentFilter: $documentFilter
      userIds: $userIds
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      tagIds: $tagIds
      withoutTags: $withoutTags
      nameSearch: $nameSearch
    ) {
      ...editorBlockDocumentListFragment
    }
  }
  ${editorBlockDocumentListFragment}
`;

export const getDocumentQuery = gql`
  query Document($documentId: String!) {
    document(documentId: $documentId) {
      ...editorBlockDocumentFragment
    }
  }
  ${editorBlockDocumentFragment}
`;

export const getAllProductsQuery = gql`
  query getAllProducts(
    $searchTerms: String!
    $limit: Int!
    $offset: Int!
    $sort: String!
    $sortBy: SortAttributes!
  ) {
    getAllProducts(
      searchTerms: $searchTerms
      limit: $limit
      offset: $offset
      sort: $sort
      sortBy: $sortBy
    ) {
      products {
        ...productListFragment
      }
      totalCount
    }
  }
  ${productListFragment}
`;

export const documentEditorContentVersionsQuery = gql`
  query DocumentEditorContentVersions($documentId: String!) {
    latestContentVersions(documentId: $documentId) {
      blockId
      editorBlockVersion
    }
  }
`;

export const latestDealroomContentVersionsQuery = gql`
  query LatestDealroomContentVersions($dealroomId: String!) {
    latestDealroomContentVersions(dealroomId: $dealroomId) {
      blockId
      editorBlockVersion
    }
  }
`;

export const previewLinkQuery = gql`
  query PreviewLink($targetUrl: String!) {
    previewContentLinkBlock(url: $targetUrl) {
      url
      title
      thumbUrl
      description
    }
  }
`;

export const loadEditorBlock = gql`
  query EditorBlock($id: String!) {
    editorBlock(id: $id) {
      ...editorBlockFragment
    }
  }
  ${editorBlockFragment}
`;
